// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uBkon","col":"styles_col__2yD1z"};